<template>
  <section class="w-full flex-grow flex flex-col p-2">
    <EditGift :giftId="$route.params.giftId" :eventId="$route.params.eventId" />
  </section>
</template>

<script>
import EditGift from "./EditGift.vue";

export default {
  name: "EditGiftPage",
  components: {
    EditGift,
  },
  props: ["giftId", "eventId"],
};
</script>
